import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChangeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.25 2.25V9.25H7.75M12.25 2.25L10 4.5M12.25 2.25L14.5 4.5M3.75 13.75L3.75 6.75H8.25M3.75 13.75L6 11.5M3.75 13.75L1.5 11.5" })
});
export default SvgChangeIcon;
